import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6acdefbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-list-wrapper relative" }
const _hoisted_2 = {
  key: 0,
  class: "bg-gradient-to-r from-white absolute left-0 top-0 h-40 w-32 flex justify-start items-center z-1"
}
const _hoisted_3 = {
  key: 0,
  class: "bg-gradient-to-l from-white absolute right-0 top-0 h-40 w-32 flex justify-end items-center z-1"
}
const _hoisted_4 = ["onClick"]

import { TabGroup, TabList, Tab, TabPanels } from '@headlessui/vue';
import { computed, onMounted, Ref, ref } from 'vue';
import useTabDynamicUnderline from '@/shared/navigation/tabs/useTabDynamicUnderline';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabTitles: { default: () => [] },
    defaultIndex: { default: 0 }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { tabTitles: string[], defaultIndex: number }

const tabListWrapper: Ref<{ $el: HTMLElement } | null> = ref(null);
const showTabOverflowRightButton: Ref<boolean> = ref(false);
const showTabOverflowLeftButton: Ref<boolean> = ref(false);
const { removeUnderline, setUnderlineAnimation, setDefaultUnderline, targetWidth, targetXPosition, tabElementList } = useTabDynamicUnderline();

const allowArrowsToBeShown = computed(() => {
    return tabListWrapper.value && ((tabListWrapper.value.$el.clientWidth * 2) >= tabListWrapper.value.$el.scrollWidth);
});

onMounted(() => {
    setDefaultUnderline(props.defaultIndex);
    const tabListHasScroll = tabListWrapper.value && tabListWrapper.value?.$el.scrollWidth > tabListWrapper.value?.$el.clientWidth;
    if (tabListHasScroll && allowArrowsToBeShown.value) {
        showTabOverflowRightButton.value = true;
    }
});





const filteredTitles = computed(() => props.tabTitles?.filter(t => t !== ''));

const scrollTo = (isLeft: boolean = true) => {
    if (tabListWrapper.value) {
        tabListWrapper.value.$el.scrollTo({
            left: isLeft ? 0 : tabListWrapper.value?.$el.scrollWidth,
            behavior: 'smooth',
        });
    }
    showTabOverflowRightButton.value = isLeft;
    showTabOverflowLeftButton.value = !isLeft;
};

const handleScroll = () => {
    if (tabListWrapper.value && allowArrowsToBeShown.value) {
        showTabOverflowRightButton.value = tabListWrapper.value.$el.scrollLeft + tabListWrapper.value?.$el.clientWidth !== tabListWrapper.value.$el.scrollWidth;
        showTabOverflowLeftButton.value = tabListWrapper.value?.$el.scrollLeft > 0;
    }
};

const dynamicUnderlineWidthAndPosition = computed(() => {
    return {
        'max-width': `${targetWidth.value}px`,
        transform: `translateX(${targetXPosition.value}px)`,
    };
});

const handleClick = (idx: number) => emit('click', idx);


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_unref(TabGroup), { "default-index": __props.defaultIndex }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "o-anim-fade-200",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (showTabOverflowLeftButton.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
                  _createVNode(_component_c_icon, {
                    name: "icon-arrow-small",
                    class: "w-12 h-12 rotate-180",
                    onClick: scrollTo
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "o-anim-fade-200",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (showTabOverflowRightButton.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_3, [
                  _createVNode(_component_c_icon, {
                    name: "icon-arrow-small",
                    class: "w-12 h-12",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo(false)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(TabList), {
          ref_key: "tabListWrapper",
          ref: tabListWrapper,
          class: "mb-x3 sm:mb-x4 whitespace-nowrap flex no-scrollbar overflow-x-scroll relative",
          onScroll: handleScroll
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTitles), (title, i) => {
              return (_openBlock(), _createBlock(_unref(Tab), {
                ref_for: true,
                ref: el => {_unref(tabElementList)[i] = el},
                key: title,
                class: "relative",
                as: "template",
                onMouseover: ($event: any) => (_unref(setUnderlineAnimation)(i)),
                onMouseout: _unref(removeUnderline)
              }, {
                default: _withCtx(({selected}) => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["mr-x4 h-40 focus:outline-none", {'tab--active': selected}]),
                    onClick: ($event: any) => (handleClick(i))
                  }, _toDisplayString(title), 11, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["onMouseover", "onMouseout"]))
            }), 128)),
            _createElementVNode("div", {
              "aria-hidden": "true",
              class: "dynamic-underline",
              style: _normalizeStyle(_unref(dynamicUnderlineWidthAndPosition))
            }, null, 4)
          ]),
          _: 1
        }, 512)
      ]),
      _createVNode(_unref(TabPanels), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["default-index"]))
}
}

})